import { render, staticRenderFns } from "./ExternalModules.vue?vue&type=template&id=a408d0d4&scoped=true&"
import script from "./ExternalModules.vue?vue&type=script&lang=js&"
export * from "./ExternalModules.vue?vue&type=script&lang=js&"
import style0 from "./ExternalModules.vue?vue&type=style&index=0&id=a408d0d4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a408d0d4",
  null
  
)

export default component.exports